import { businessErrorFactory, BusinessError } from '../../../../../common/business-error';
import errors from '../../../../../../constants/errors';

enum BUSINESS_ERRORS {
  'OPERATION_NOT_FOUND' = 'OPERATION_NOT_FOUND'
}

export const operationDetailsBusinessError = (businessError: unknown): BusinessError | null => {
  switch (businessError) {
    case BUSINESS_ERRORS.OPERATION_NOT_FOUND: {
      return businessErrorFactory({ message: errors.operationNotFound, severity: 'warning' });
    }
    default: {
      return null;
    }
  }
};
